import { render, staticRenderFns } from "./EmptyLayout3.vue?vue&type=template&id=7825909b&scoped=true&"
import script from "./EmptyLayout3.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout3.vue?vue&type=script&lang=js&"
import style0 from "./EmptyLayout3.vue?vue&type=style&index=0&id=7825909b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825909b",
  null
  
)

export default component.exports